import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Dummy from 'bloko/blocks/treeSelector/treeSelectorDummy';
import { fromTree } from 'bloko/common/tree/treeCollectionHelper';
import ImmutableSelectionStrategy from 'bloko/common/tree/immutableSelectionStrategy';

export const TreeSelectorDummy = Dummy;

/**
 * Компонент для работы с древовидной структурой данных.
 * Получает дерево в виде JSON и изначально выбранные и открытые элементы,
 * далее управляет ими сам. Если нужно ручное управление `selected`,
 * см. компонент <a href="#treeselectordummy">TreeSelectorDummy</a>.
 */
export default class TreeSelector extends PureComponent {
    collection = fromTree(this.props.data);
    leavesOnly = this.props.leavesOnly;
    singleChoice = this.props.singleChoice;
    selectionStrategy = new ImmutableSelectionStrategy(this.collection, {
        singleChoice: this.singleChoice,
        leavesOnly: this.leavesOnly,
    });

    state = {
        selected: this.props.initialSelected.slice(),
    };

    handleChange = (id, isSelected) => {
        const { onChange } = this.props;
        const { selected: previousSelected } = this.state;
        const selected = isSelected
            ? this.selectionStrategy.add(previousSelected, [id])
            : this.selectionStrategy.remove(previousSelected, [id]);
        this.setState({ selected });
        onChange(id, isSelected, selected.slice());
    };

    render() {
        const {
            disabled,
            initialExpanded,
            LabelComponent,
            contentFilterQuery,
            onChangeFilterQuery,
            onExpand,
        } = this.props;
        const { selected } = this.state;
        return (
            <TreeSelectorDummy
                collection={this.collection}
                singleChoice={this.singleChoice}
                leavesOnly={this.leavesOnly}
                selected={selected}
                disabled={disabled}
                initialExpanded={initialExpanded}
                LabelComponent={LabelComponent}
                onChange={this.handleChange}
                onExpand={onExpand}
                contentFilterQuery={contentFilterQuery}
                onChangeFilterQuery={onChangeFilterQuery}
            />
        );
    }

    static propTypes = {
        /** Дерево элементов. */
        data: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                text: PropTypes.string.isRequired,
                additional: PropTypes.object,
                items: PropTypes.array,
            })
        ).isRequired,
        /** Разрешает выбор только элементов без потомков. */
        leavesOnly: PropTypes.bool,
        /** Разрешает выбор только одного элемента. */
        singleChoice: PropTypes.bool,
        /** Изначально выбранные ID. */
        initialSelected: PropTypes.arrayOf(PropTypes.string),
        /** Изначально открытые ID. */
        initialExpanded: PropTypes.arrayOf(PropTypes.string),
        /** Запрещённые ID. */
        disabled: PropTypes.arrayOf(PropTypes.string),
        /** Компонент для вывода метки */
        LabelComponent: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.instanceOf(React.Component),
            PropTypes.instanceOf(React.PureComponent),
        ]),
        /** Обработчик изменения набора выбранных ID.
         * В аргументах получает `{String} id`, `{Boolean} isSelected`, `{Array} allSelected`. */
        onChange: PropTypes.func,
        /** Обработчик изменения состояния раскрытия элементов
         * В аргументах получает список id раскрытых элементов `{Array} expanded` */
        onExpand: PropTypes.func,
        /** Фильтр для дерева, остаются только элементы со вхождением указанной строки. */
        contentFilterQuery: PropTypes.string,
        /** Обработчик изменения строки contentFilterQuery
         * В аргументах получает список подходящих под запрос id */
        onChangeFilterQuery: PropTypes.func,
    };

    static defaultProps = {
        singleChoice: false,
        leavesOnly: false,
        disabled: [],
        initialSelected: [],
        initialExpanded: [],
        onChange: () => {},
        contentFilterQuery: null,
    };
}
